import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Modal,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from '../../../assets/images/nopdf.png'

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};



type Props = {};

const DocViewerAdd = (props: Props) => {

    const [TypeOption, setTypeOption] = useState<any>([{ value: "-1", label: "SelectFile" }]);
    const [GroupOption, setGroupOption] = useState<any>([{ value: "-1", label: "SelectFileGroup" }]);
    const [CategoryOption, setCategoryOption] = useState<any>([{ value: "-1", label: "SelectFileCategory" }]);
    const [selectedField, setSelectedField] = useState(null);





    useEffect(() => {
        getFileType();
        getFileGroup();
        getCategory();

    }, []);


    const getFileType = () => {
        const collectData = {
            fileTypeId: -1,
        };
        axios
            .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileTypeName,
                    value: item.fileTypeId
                }));
                setTypeOption(arr);
            })

    };

    const getFileGroup = () => {
        const collectData = {
            fileGroupid: -1,
        };
        axios
            .post(HOST_URL.HOST_URL2 + `FileGroup/GetFileGroup`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileGroupName,
                    value: item.fileGroupid
                }));
                setGroupOption(arr);
            })

    };

    const getCategory = () => {
        const collectData = {
            fileCatid: -1,
        };
        axios
            .post(HOST_URL.HOST_URL2 + `FileCategory/GetFileCategory`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileCatDesc,
                    value: item.fileCatid
                }));
                setCategoryOption(arr);
            })

    };




    const handleFieldSelect = (field: any) => {
        setSelectedField(field);
    };







    let navigate = useNavigate();
    const { i18n, t } = useTranslation();

    const [toaster, setToaster] = useState(false);





    const formik = useFormik({
        initialValues: {
            fileID: -1,

            fileType: 0,
            fileGroup: 0,
            fileCategory: 0,

        },


        onSubmit: async (values) => {

            console.log("Before submission formik values", values);

            // Handle form submission
            try {
                const response = await axios.post(
                    HOST_URL.HOST_URL2 + `FileDetail/AddUpdateFileDetails`,



                    values
                );
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                    navigate('/DocManagement/DocViewer');
                } else {
                    toast.error(response.data.mesg);
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred. Please try again.");
            }
        },


    });

    const requiredFields = ['']


    const back = useNavigate();




    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh"
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        Doc Viewer Add
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>

                            <Grid item xs={12}>
                                <Autocomplete
                                    disablePortal
                                    options={['fileType', 'fileGroup', 'fileCategory']}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue) => {
                                        handleFieldSelect(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Field"
                                        />
                                    )}
                                />
                            </Grid>

                            {selectedField && (
                                <Grid item xs={12}>
                                    {selectedField === 'fileType' && (
                                        <Autocomplete
                                            disablePortal
                                            id="fileType"
                                            options={TypeOption}
                                            // value={
                                            //     TypeOption.find(
                                            //         (option: any) => option.value === formik.values.fileType
                                            //     ) || null
                                            // }
                                            fullWidth
                                            size="small"
                                            onChange={(event, newValue: any) => {
                                                formik.setFieldValue("fileType", newValue?.value);
                                                formik.setFieldTouched("fileType", true);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select File Type"
                                                />
                                            )}
                                        />
                                    )}
                                    {selectedField === 'fileGroup' && (
                                        <Autocomplete
                                            disablePortal
                                            id="fileGroup"
                                            options={GroupOption}
                                            // value={
                                            //     GroupOption.find(
                                            //         (option: any) => option.value === formik.values.fileGroup
                                            //     ) || null
                                            // }
                                            fullWidth
                                            size="small"
                                            onChange={(event, newValue: any) => {
                                                formik.setFieldValue("fileGroup", newValue?.value);
                                                formik.setFieldTouched("fileGroup", true);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select File Group"
                                                />
                                            )}
                                        />
                                    )}
                                    {selectedField === 'fileCategory' && (
                                        <Autocomplete
                                            disablePortal
                                            id="fileCategory"
                                            options={CategoryOption}
                                            // value={
                                            //     CategoryOption.find(
                                            //         (option: any) => option.value === formik.values.fileCategory
                                            //     ) || null
                                            // }
                                            fullWidth
                                            size="small"
                                            onChange={(event, newValue: any) => {
                                                formik.setFieldValue("fileCategory", newValue?.value);
                                                formik.setFieldTouched("fileCategory", true);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select File Category"
                                                />
                                            )}
                                        />
                                    )}
                                    {selectedField && formik.touched[selectedField] && formik.errors[selectedField] && (
                                        <div style={{ color: "red", margin: "5px" }}>
                                            {formik.errors[selectedField]}
                                        </div>
                                    )}
                                </Grid>
                            )}


                            <Grid item lg={12} xs={12}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue="Search Whole" // or value="Search Whole"
                                    >
                                        <FormControlLabel value="Search Whole" control={<Radio />} label="Search Whole" />
                                        <FormControlLabel value="Any Word" control={<Radio />} label="Any Word" />
                                        <FormControlLabel value="Extra Option" control={<Radio />} label="Extra Option" />
                                        <FormControlLabel value="Search in comment" control={<Radio />} label="Search in comment" />
                                    </RadioGroup>
                                </FormControl>

                            </Grid>


                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#059669",
                                            color: "white",
                                            marginTop: "10px",
                                        }}

                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    </form>

                </CardContent>
            </div>
        </div>
    );
};

export default DocViewerAdd;